import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d98db24a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "no-results"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ingen resultat", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "product-list-info" }
const _hoisted_6 = { class: "product-list-info__numbers" }
const _hoisted_7 = { class: "product-list-pagination product-list-info__pagination" }
const _hoisted_8 = {
  key: 0,
  class: "product-list-info__buttons"
}
const _hoisted_9 = { class: "product-table-wrapper" }
const _hoisted_10 = { class: "mobile-list" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "VareID", -1))
const _hoisted_12 = { class: "result" }
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Varenavn", -1))
const _hoisted_15 = ["href"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { style: {"font-weight":"bold"} }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Utpris ink. mva", -1))
const _hoisted_21 = { class: "result" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Fortjeneste", -1))
const _hoisted_23 = { class: "result" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "%", -1))
const _hoisted_25 = { class: "result" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Lager", -1))
const _hoisted_27 = { class: "result" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Handling", -1))
const _hoisted_29 = {
  key: 0,
  class: "result"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "mobile-none" }, "VareID", -1))
const _hoisted_31 = {
  key: 0,
  class: "mobile-none"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Varenavn", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Har beskrivelse", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Utpris ink. mva", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Fortjeneste", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "%", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Lager", -1))
const _hoisted_38 = { key: 1 }
const _hoisted_39 = ["href"]
const _hoisted_40 = {
  key: 0,
  class: "mobile-none"
}
const _hoisted_41 = { class: "product-name-td" }
const _hoisted_42 = ["href"]
const _hoisted_43 = ["src"]
const _hoisted_44 = { class: "mobile-none" }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "product-list-pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PrintPriceTags = _resolveComponent("PrintPriceTags")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ProductActions = _resolveComponent("ProductActions")!

  return (_ctx.products?.total === 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_ctx.products)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, " Viser " + _toDisplayString(_ctx.products.data.length) + " av totalt " + _toDisplayString(_ctx.products.total) + " produkter ", 1),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Pagination, {
                size: _ctx.paginationSize,
                paginate: _ctx.products,
                preserveScroll: ""
              }, null, 8, ["size", "paginate"])
            ]),
            (_ctx.products.total > 0 && _ctx.showPrintButton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_Button, {
                    color: "secondary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printPriceTagsOpen = true))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SvgIcon, {
                        type: "mdi",
                        path: _ctx.priceTagIcon
                      }, null, 8, ["path"]),
                      _createTextVNode(" Skriv ut prislapper")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_PrintPriceTags, {
                    onDismiss: _cache[1] || (_cache[1] = ($event: any) => (_ctx.printPriceTagsOpen = false)),
                    open: _ctx.printPriceTagsOpen,
                    numberOfTags: _ctx.products.total
                  }, null, 8, ["open", "numberOfTags"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.showReload && !_ctx.printMode)
            ? (_openBlock(), _createBlock(_component_Card, {
                key: 0,
                class: "refresh-button"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Button, {
                    type: "button",
                    onClick: _ctx.reloadPage,
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.reloadLoading)
                        ? (_openBlock(), _createBlock(_component_SvgIcon, {
                            key: 0,
                            class: "animate-spin",
                            type: "mdi",
                            path: _ctx.loadingIcon
                          }, null, 8, ["path"]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" Oppdater listen")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products?.data, (product) => {
                  return (_openBlock(), _createElementBlock("li", null, [
                    _hoisted_11,
                    _createElementVNode("p", _hoisted_12, [
                      _createElementVNode("a", {
                        class: "product-link",
                        href: `/l-products/view-product/${product.id}`,
                        target: "_blank"
                      }, _toDisplayString(product.id), 9, _hoisted_13)
                    ]),
                    _hoisted_14,
                    _createElementVNode("a", {
                      class: "product-link product-name result",
                      href: `/l-products/view-product/${product.id}`,
                      target: "_blank"
                    }, [
                      _createElementVNode("img", {
                        class: "product-image",
                        src: product.main_image?.url,
                        alt: ""
                      }, null, 8, _hoisted_16),
                      _createElementVNode("span", null, _toDisplayString(product.name), 1),
                      (product.type == 'variation')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _hoisted_18,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.variation_attributes, (attribute) => {
                              return (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(attribute.name + ": " + attribute.pivot.value + ""), 1))
                            }), 256))
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_15),
                    _hoisted_20,
                    _createElementVNode("p", _hoisted_21, " kr " + _toDisplayString(product.normal_price_with_mva?.toLocaleString("nb")), 1),
                    _hoisted_22,
                    _createElementVNode("p", _hoisted_23, " kr " + _toDisplayString((product.price - product.cost).toLocaleString("nb", {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2,
                })), 1),
                    _hoisted_24,
                    _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.getPercentProfit(product).toLocaleString("nb", {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2,
                })) + "% ", 1),
                    _hoisted_26,
                    _createElementVNode("p", _hoisted_27, _toDisplayString(product.stock) + " " + _toDisplayString(product.unit ?? "stk"), 1),
                    _hoisted_28,
                    (!_ctx.printMode)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
                          _createVNode(_component_ProductActions, {
                            product: product,
                            canDelete: _ctx.isAdmin,
                            "show-print-button": _ctx.showPrintButton
                          }, null, 8, ["product", "canDelete", "show-print-button"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 256))
              ])
            ]),
            _createVNode(_component_Card, null, {
              default: _withCtx(() => [
                _createElementVNode("table", {
                  class: _normalizeClass(["product-table", {
            'no-print': !_ctx.printMode,
          }])
                }, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_30,
                      (_ctx.showWcId)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_31, "WC VareID"))
                        : _createCommentVNode("", true),
                      _hoisted_32,
                      _hoisted_33,
                      _hoisted_34,
                      _hoisted_35,
                      _hoisted_36,
                      _hoisted_37,
                      (!_ctx.printMode)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_38, "Handling"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products.data, (product) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", null, [
                          _createElementVNode("a", {
                            class: "product-link",
                            href: `/l-products/view-product/${product.id}`,
                            target: "_blank"
                          }, _toDisplayString(product.id), 9, _hoisted_39)
                        ]),
                        (_ctx.showWcId)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_40, _toDisplayString(product.wc_product_id), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", _hoisted_41, [
                          _createElementVNode("a", {
                            class: "product-link product-name",
                            href: `/l-products/view-product/${product.id}`,
                            target: "_blank"
                          }, [
                            _createElementVNode("img", {
                              class: "product-image",
                              src: product.main_image?.url,
                              alt: ""
                            }, null, 8, _hoisted_43),
                            _createElementVNode("span", null, _toDisplayString(product.name), 1)
                          ], 8, _hoisted_42)
                        ]),
                        _createElementVNode("td", _hoisted_44, _toDisplayString(product.description === null ||
                  product.description?.trim() === ""
                    ? "Nei"
                    : "Ja"), 1),
                        _createElementVNode("td", null, " kr " + _toDisplayString(product.normal_price_with_mva?.toLocaleString("nb")), 1),
                        _createElementVNode("td", null, " kr " + _toDisplayString((product.price - product.cost).toLocaleString("nb", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                  })), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.getPercentProfit(product).toLocaleString("nb", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                  })) + "% ", 1),
                        _createElementVNode("td", null, _toDisplayString(product.stock) + " " + _toDisplayString(product.unit ?? "stk"), 1),
                        (!_ctx.printMode)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_45, [
                              _createVNode(_component_ProductActions, {
                                product: product,
                                canDelete: _ctx.isAdmin,
                                "show-print-button": _ctx.showPrintButton
                              }, null, 8, ["product", "canDelete", "show-print-button"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 256))
                  ])
                ], 2)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_Pagination, {
              size: _ctx.paginationSize,
              paginate: _ctx.products
            }, null, 8, ["size", "paginate"])
          ])
        ]))
      : _createCommentVNode("", true)
}